/**
 * M2M authentication via Okta Client Credentials / OIDC
 */

export { createJwtAuthPlugin as default } from './plugin';
